export const getIsSponsored = advertisement => !!advertisement;
